(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Jsw"] = factory();
	else
		root["Jsw"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 177);
/******/ })
/************************************************************************/
/******/ ({

/***/ 177:
/* no static exports found */
/* all exports used */
/*!***********************!*\
  !*** ./app/search.js ***!
  \***********************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

module.exports = function (_ref) {
    var searchTerm = _ref.searchTerm,
        iconState = _ref.iconState,
        searchResultsBlock = _ref.searchResultsBlock,
        locale = _ref.locale,
        skinUrl = _ref.skinUrl,
        actionUrl = _ref.actionUrl;

    var searchActionDelay = 200;
    var timer = void 0;
    var enterPressed = false;
    var pendingRequest = void 0;

    var lmsg = function lmsg(localeKey) {
        return locale[localeKey].escapeHTML();
    };

    var fatalError = function fatalError(message) {
        // eslint-disable-next-line no-alert
        alert(message);
    };

    var onPasteHandler = function onPasteHandler() {
        return scheduleSearch();
    };

    var onKeyUpHandler = function onKeyUpHandler(event) {
        if ([Jsw.keyCode.UP_ARROW, Jsw.keyCode.DOWN_ARROW, Jsw.keyCode.LEFT_ARROW, Jsw.keyCode.RIGHT_ARROW, Jsw.keyCode.ENTER].indexOf(event.keyCode) !== -1) {
            return;
        }

        scheduleSearch();
    };

    var onKeyDownHandler = function onKeyDownHandler(event) {
        if ([Jsw.keyCode.UP_ARROW, Jsw.keyCode.DOWN_ARROW].indexOf(event.keyCode) !== -1) {
            onArrowKeyPressed(event.keyCode);
        }

        enterPressed = Jsw.keyCode.ENTER === event.keyCode;
        if (enterPressed) {
            scheduleSearch();
        }
    };

    var onFocusHandler = function onFocusHandler() {
        searchTerm.value = '';
        searchTerm.removeClassName('search-empty');
    };

    var onBlurHandler = function onBlurHandler() {
        // workaround for Google Chrome
        setTimeout(function () {
            showSearchFieldStub();
            setTimeout(resetSearch, 300);
        }, 0);
    };

    var showSearchFieldStub = function showSearchFieldStub() {
        searchTerm.value = '';
        searchTerm.blur();
    };

    var scheduleSearch = function scheduleSearch() {
        iconState.removeClassName('icon-search');
        iconState.addClassName('icon-indicator');

        abortPreviousSearch();
        timer = setTimeout(findTerm, searchActionDelay);
    };

    var abortPreviousSearch = function abortPreviousSearch() {
        if (pendingRequest) {
            var abort = pendingRequest.abort.bind(pendingRequest);
            // global state is cleared first due to onSearchComplete callback
            pendingRequest = null;
            abort();
        }

        if (timer) {
            clearTimeout(timer);
        }
    };

    var onSearchSuccess = function onSearchSuccess(response) {
        if (searchTerm.value !== response.request.options.parameters.term) {
            return;
        }

        var data = void 0;
        try {
            data = response.responseText.evalJSON();
        } catch (e) {
            fatalError('Failed to parse JSON response: ' + e.message);
            return;
        }

        if ('error' === data.status) {
            var result = '';
            data.statusMessages.each(function (message) {
                result += message.title + ': ' + message.content + '\n';
            });
            fatalError(result);
            return;
        }

        if (enterPressed) {
            goToSelectedItem(data);
        } else {
            showResults(data);
        }
    };

    var onSearchFailure = function onSearchFailure(response) {
        fatalError('Search request failed due to following error: ' + response.responseText);
    };

    var onSearchComplete = function onSearchComplete(response) {
        if (!response || pendingRequest === response.request) {
            iconState.removeClassName('icon-indicator');
            iconState.addClassName('icon-search');
        }
    };

    var goToSelectedItem = function goToSelectedItem(results) {
        var activeRow = searchResultsBlock.down('li.active');

        if (!activeRow) {
            activeRow = searchResultsBlock.down('li');
        }

        if (activeRow && activeRow.down('a')) {
            Jsw.redirect(activeRow.down('a').href, null, activeRow.down('a').target);
        } else if (results.records.length) {
            Jsw.redirect(results.records[0].link, null, results.records[0].target);
        } else {
            showResults(results);
        }
    };

    var showResults = function showResults(results) {
        var resultsHtml = '';

        if (0 === results.records.size()) {
            resultsHtml += '<li><div class="search-results-note">' + lmsg('nothingFound') + '</div></li>';
        } else {
            results.records.each(function (item) {
                var itemDetails = 'undefined' !== typeof item.details ? item.details.escapeHTML() : '';
                var linkTarget = '';
                if (item.target) {
                    linkTarget = 'target="' + item.target + '"';
                }
                var iconUrl = !item.icon || item.icon.startsWith(skinUrl) || item.icon.startsWith('http://') || item.icon.startsWith('https://') || item.icon.startsWith('/modules/') ? item.icon : '' + skinUrl + item.icon;

                resultsHtml += '<li>\n                        <a href="' + item.link.escapeHTML() + '" title="' + itemDetails + '" ' + linkTarget + '>\n                            ' + (iconUrl ? '<i class="icon-" style="background-image: url(' + iconUrl.escapeHTML() + ')"></i>' : '') + '\n                            ' + item.title.escapeHTML() + '\n                        </a>\n                    </li>';
            });

            if (results.meta.moreResultsFound) {
                resultsHtml += '<li>\n                        <div class="search-results-note">' + lmsg('moreResultsFound') + '</div>\n                    </li>';
            }
        }

        searchResultsBlock.update(resultsHtml);

        var links = searchResultsBlock.select('a');
        links.each(function (link) {
            link.observe('mouseover', onItemMouseOver.bind(link));
            link.observe('mouseout', onItemMouseOut.bind(link));
        });
        if (0 !== links.size()) {
            links.first().up('li').addClassName('active');
        }

        searchResultsBlock.up('.dropdown').addClassName('open');
    };

    var onItemMouseOver = function onItemMouseOver() {
        var oldActiveLink = searchResultsBlock.select('li.active')[0];

        if (oldActiveLink) {
            oldActiveLink.removeClassName('active');
        }

        this.up('li').addClassName('active');
    };

    var onItemMouseOut = function onItemMouseOut() {
        this.up('li').removeClassName('active');
    };

    var resetSearch = function resetSearch() {
        searchResultsBlock.up('.dropdown').removeClassName('open');

        abortPreviousSearch();
        onSearchComplete();
    };

    var onArrowKeyPressed = function onArrowKeyPressed(keyCode) {
        if (0 === searchResultsBlock.select('a').length) {
            return;
        }

        var activeRow = searchResultsBlock.down('li.active');

        if (!activeRow) {
            searchResultsBlock.down('li').addClassName('active');
            return;
        }

        if (Jsw.keyCode.DOWN_ARROW === keyCode) {
            var nextRow = activeRow.next();

            if (nextRow && nextRow.down('a')) {
                activeRow.removeClassName('active');
                nextRow.addClassName('active');
            }
        }

        if (Jsw.keyCode.UP_ARROW === keyCode) {
            var prevRow = activeRow.previous();

            if (prevRow && prevRow.down('a')) {
                activeRow.removeClassName('active');
                prevRow.addClassName('active');
            }
        }
    };

    var findTerm = function findTerm() {
        var term = searchTerm.value;

        if ('' === term) {
            resetSearch();
            return;
        }

        pendingRequest = new Ajax.Request(actionUrl, {
            method: 'get',
            parameters: { term: term },
            onSuccess: onSearchSuccess,
            onFailure: onSearchFailure,
            onComplete: onSearchComplete
        });
    };

    searchTerm.observe('paste', onPasteHandler);
    searchTerm.observe('keyup', onKeyUpHandler);
    searchTerm.observe('keydown', onKeyDownHandler);
    searchTerm.observe('focus', onFocusHandler);
    searchTerm.observe('blur', onBlurHandler);
};

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// javascript/app/search.js